<template>
  <v-container fill-height>
    <v-layout column>
      <v-flex xs12>
        <h1 class="display-1 mb-5 text-xs-center">Password Reset Email</h1>
        <form novalidate @submit.prevent="whenValid(onSubmit)">
          <v-text-field
            v-model="form.email"
            v-validate="'required|email'"
            :error-messages="errors.collect('email')"
            label="E-mail"
            type="email"
            data-vv-name="email"
            required
            autofocus
          >
          </v-text-field>
          <v-btn
            large
            color="primary"
            type="submit"
            data-test="resetEmail-button"
            class="mt-3"
          >
            Send Password Reset Link
          </v-btn>
          <v-alert
            :value="emailResetError"
            color="error"
            icon="fas fa-exclamation-triangle"
            outline
            class="mt-3"
          >
            {{ emailResetError }}
          </v-alert>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import validate from '../../../mixins/validate';
import { email } from '../../../api/auth';

export default {
  name: 'Email',
  mixins: [validate],
  $_veeValidate: {
    validator: 'new',
  },
  metaInfo: {
    title: 'Email Password Reset',
  },
  data() {
    return {
      form: {
        email: '',
      },
      error: null,
      dictionary: {
        attributes: {
          email: 'E-mail Address',
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      emailResetError: 'emailResetError',
    }),
    // emailResetError() {
    //   return this.$store.getters.emailResetError;
    // },
  },
  mounted() {
    this.$validator.localize('en', this.dictionary);
  },
  methods: {
    ...mapMutations(['showSnackbar', 'closeSnackbar']),
    email() {
      this.$store.dispatch('email');
      email(this.$data.form)
        .then((res) => {
          this.$store.commit('emailResetSuccess', res);
          this.clear();
          this.emailResetSuccess();
        })
        .then(() => this.$router.push({ path: '/' }))
        .catch((error) => {
          this.$store.commit('emailResetFailed', { error });
          this.emailResetFailed();
        });
    },
    emailResetSuccess() {
      this.showSnackbar({
        text: 'Your password reset email was sent!',
        color: 'success',
        timeout: 5000,
      });
    },
    emailResetFailed() {
      this.showSnackbar({
        text: 'There was a problem with your email credential!',
        color: 'warning',
        timeout: 5000,
      });
    },
    clear() {
      this.form.email = '';
      this.$validator.reset();
    },
  },
};
</script>
